import React, { useState, useContext } from 'react';
import { Typography, Box, Button, Rating, TextField } from '@mui/material';
import FormBox from './building_blocks/FormBox';
import orderReviewsPathTo from '../utils/Api/orderReviewsPathTo'
import SnackbarContext from '../contexts/SnackbarContext';

const OrderReview = (props) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const { openSnackbar } = useContext(SnackbarContext);
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!rating) {
      openSnackbar("Por favor, avalie o pedido!", "error");
      return;
    }
    orderReviewsPathTo.save({rating: rating, comment: comment, order_id: props.order.id}).then(result => {
      // returns updated order
      props.setOrder(result.data);
      console.log(result);
      openSnackbar("Muito obrigado por avaliar o pedido!", "success");
    })
  }
  return (
    <Box>
      <FormBox>
        <Typography color="primary" variant="h5">Avaliação do Pedido</Typography>
        
        <form onSubmit={handleSubmit}>
          <Box display="flex" alignItems="center" flexDirection="column" gap={2}>
            <Box pt={2}>
              <Rating
                name="rating"
                size="large"
                value={rating}
                onChange={(event, newValue) => {
                  setRating(newValue);
                }}
              />
            </Box>

            <TextField
              label="Comentário (opcional)"
              multiline
              variant="outlined"
              fullWidth
              value={comment}
              onChange={(event) => setComment(event.target.value)}
            />

            <Button type="Submit" variant="contained" sx={{ alignSelf: 'end'}}>
              Enviar Avaliação
            </Button>
          </Box>
        </form>
      </FormBox>
    </Box>
  )
}

export default OrderReview